module.exports = __webpack_public_path__ + "static/media/blu_banner_1409.d910e47e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blu_banner_1409.jpg
// module id = 1640
// module chunks = 0